const services = [
  {
    imageSrc: "/services/home-remodeling-services-in-los-angeles.webp",
    title: "Complete Remodeling",
    description: "A comprehensive service that renovates your entire home to suit your needs and preferences.",
    link: "/services/complete-home-remodeling",
    height: "h-[467px]",
  },
  {
    imageSrc: "/services/kitchen-remodeling-services-in-los-angeles.webp",
    title: "Kitchen Remodeling",
    description: "Transform your kitchen into a modern, functional space perfect for family gatherings.",
    link: "/services/kitchen-remodeling",
    height: "h-[467px]",
  },
  {
    imageSrc: "/services/bathroom-remodeling-contractor-in-los-angeles.webp",
    title: "Bathroom Remodeling",
    description: "Create a relaxing and functional bathroom with modern features and elegant design.",
    link: "/services/bathroom-remodeling",
    height: "h-[467px]",
  },
  {
    imageSrc: "/services/adu-garage-conversion-services-in-los-angeles.webp",
    title: "ADU / Garage Conversion",
    description: "Convert your garage into a functional space with options like an ADU or home office.",
    link: "/services/adu",
    height: "h-[338px]",
  },
  {
    imageSrc: "/services/outdoor-living-services-in-los-angeles.webp",
    title: "Outdoor Living",
    description: "Enhance your outdoor space with patios, decks, and more for a perfect backyard retreat.",
    link: "/services/outdoor-living",
    height: "h-[338px]",
  },
  {
    imageSrc: "/services/best-foundations-remodeling-services-in-los-angeles.webp",
    title: "Foundation Work",
    description: "Ensure your home’s stability with expert foundation inspection, repair, and installation services.",
    link: "/services/foundations",
    height: "h-[467px]",
  },
  {
    imageSrc: "/services/best-earthquake-retrofit-services-in-los-angeles.webp",
    title: "Earthquake Retrofit",
    description: "Strengthen your home against earthquakes with modern structural reinforcement solutions.",
    link: "/services/earthquake-retrofit",
    height: "h-[467px]",
  },
  {
    imageSrc: "/services/best-exterior-painting-services-in-los-angeles.webp",
    title: "Exterior Painting",
    description: "Revitalize your home’s curb appeal with professional-grade exterior painting services.",
    link: "/services/exterior-painting",
    height: "h-[467px]",
  },
  {
    imageSrc: "/services/best-energy-efficient-windows-services-in-los-angeles.webp",
    title: "Energy-Efficient Windows",
    description: "Lower energy bills and improve comfort with advanced, stylish window upgrades.",
    link: "/services/energy-efficient-windows",
    height: "h-[338px]",
  },
  {
    imageSrc: "/services/best-solar-panel-services-in-los-angeles.webp",
    title: "Solar Panels",
    description: "Power your home sustainably and save on energy costs with expert solar panel installation.",
    link: "/services/solar-panels",
    height: "h-[338px]",
  },
  {
    imageSrc: "/services/best-artificial-turf-landscaping-services-in-los-angeles.webp",
    title: "Artificial Turf",
    description: "Enjoy a lush, low-maintenance lawn year-round with professional turf installation.",
    link: "/services/artificial-turf",
    height: "h-[467px]",
  },
  {
    imageSrc: "/services/best-hvac-services-in-los-angeles.webp",
    title: "HVAC Services",
    description: "Stay comfortable all year with heating and cooling system installs, repairs, and upgrades.",
    link: "/services/hvac",
    height: "h-[467px]",
  },
  {
    imageSrc: "/services/best-pavers-hardcaping-services-in-los-angeles.webp",
    title: "Pavers & Hardscaping",
    description: "Add timeless beauty and function to driveways, patios, and walkways with premium pavers.",
    link: "/services/pavers",
    height: "h-[467px]",
  },
  {
    imageSrc: "/services/best-asphalt-shingles-roof-services-in-los-angeles.webp",
    title: "Asphalt Shingles Roof",
    description: "Affordable and durable roofing option that enhances your home’s appearance and protection.",
    link: "/services/asphalt-shingles",
    height: "h-[338px]",
  },
  {
    imageSrc: "/services/best-tile-roof-services-in-los-angeles.webp",
    title: "Tile Roof",
    description: "Elegant and long-lasting tile roofs that offer excellent insulation and curb appeal.",
    link: "/services/tile-roof",
    height: "h-[338px]",
  },
  {
    imageSrc: "/services/best-flat-roof-services-in-los-angeles.webp",
    title: "Flat Roof",
    description: "Modern flat roofing systems designed for low-slope structures with water resistance and durability.",
    link: "/services/flat-roof",
    height: "h-[467px]",
  },
  {
    imageSrc: "/services/best-metal-roof-services-in-los-angeles.webp",
    title: "Metal Roof",
    description: "High-performance metal roofs that provide superior longevity and energy efficiency.",
    link: "/services/metal-roof",
    height: "h-[467px]",
  },
  {
    imageSrc: "/services/best-tpo-roof-services-in-los-angeles.webp",
    title: "TPO Roof",
    description: "Energy-efficient, heat-reflective roofing for commercial and residential flat roof systems.",
    link: "/services/tpo-roof",
    height: "h-[467px]",
  },
  {
    imageSrc: "/services/best-rain-gutter-services-in-los-angeles.webp",
    title: "Gutter Installation",
    description: "Prevent water damage with professionally installed and maintained gutter systems.",
    link: "/services/gutter",
    height: "h-[338px]",
  },
];

export default services;




// const services = [
//   {
//     imageSrc: "/services/home-remodeling-services-in-los-angeles.webp",
//     title: "Complete Remodeling",
//     description: "A comprehensive service that renovates your entire home to suit your needs and preferences.",
//     link: "/services/complete-home-remodeling",
//     height: "h-[467px]",
//   },
//   {
//     imageSrc: "/services/kitchen-remodeling-services-in-los-angeles.webp",
//     title: "Kitchen Remodeling",
//     description: "Transform your kitchen into a modern, functional space perfect for family gatherings.",
//     link: "/services/kitchen-remodeling",
//     height: "h-[467px]",
//   },
//   {
//     imageSrc: "/services/bathroom-remodeling-contractor-in-los-angeles.webp",
//     title: "Bathroom Remodeling",
//     description: "Create a relaxing and functional bathroom with modern features and elegant design.",
//     link: "/services/bathroom-remodeling",
//     height: "h-[467px]",
//   },
//   {
//     imageSrc: "/services/adu-garage-conversion-services-in-los-angeles.webp",
//     title: "ADU / Garage Conversion",
//     description: "Convert your garage into a functional space with options like an ADU or home office.",
//     link: "/services/adu",
//     height: "h-[338px]",
//   },
//   {
//     imageSrc: "/services/best-foundations-remodeling-services-in-los-angeles.webp",
//     title: "Foundation Work",
//     description: "Ensure your home’s stability with expert foundation inspection, repair, and installation services.",
//     link: "/services/foundations",
//     height: "h-[338px]",
//   },
//   {
//     imageSrc: "/services/best-earthquake-retrofit-services-in-los-angeles.webp",
//     title: "Earthquake Retrofit",
//     description: "Strengthen your home against earthquakes with modern structural reinforcement solutions.",
//     link: "/services/earthquake-retrofit",
//     height: "h-[467px]",
//   },
//   {
//     imageSrc: "/services/best-exterior-painting-services-in-los-angeles.webp",
//     title: "Exterior Painting",
//     description: "Revitalize your home’s curb appeal with professional-grade exterior painting services.",
//     link: "/services/exterior-painting",
//     height: "h-[467px]",
//   },
//   {
//     imageSrc: "/services/best-pavers-hardcaping-services-in-los-angeles.webp",
//     title: "Pavers & Hardscaping",
//     description: "Add timeless beauty and function to driveways, patios, and walkways with premium pavers.",
//     link: "/services/pavers",
//     height: "h-[467px]",
//   },
// ];

// export default services;
